import { rivermeadowApi } from './api';

export const preflightsApi = rivermeadowApi.injectEndpoints({
    endpoints: (builder) => ({
        // Update migration context for a source
        updateMigrationContext: builder.mutation({
            query: ({ sourceId, payload }) => ({
                url: `sources/${sourceId}/migration-context`,
                method: 'PUT',
                body: payload,
            }),
            invalidatesTags: (result, error, { sourceId }) => [{ type: 'SOURCES', id: sourceId }],
        }),

        // Start preflights
        createPreflights: builder.mutation({
            query: (preflightRequests) => ({
                url: 'preflights',
                method: 'POST',
                body: preflightRequests,
            }),
            invalidatesTags: ['PREFLIGHTS'],
        }),

        // Get preflight by ID
        getPreflightById: builder.query({
            query: (preflightId) => `preflights/${preflightId}`,
            providesTags: (result, error, preflightId) => [{ type: 'PREFLIGHTS', id: preflightId }],
        }),

        // Get preflight status (for polling)
        getPreflightStatus: builder.query({
            query: (preflightId) => ({
                url: `preflights/${preflightId}`,
                params: { status_only: true },
            }),
            providesTags: (result, error, preflightId) => [{ type: 'PREFLIGHT_STATUS', id: preflightId }],
        }),
    }),
    overrideExisting: false,
});

export const {
    useUpdateMigrationContextMutation,
    useCreatePreflightsMutation,
    useGetPreflightByIdQuery,
    useGetPreflightStatusQuery,
    useLazyGetPreflightByIdQuery,
    useLazyGetPreflightStatusQuery,
} = preflightsApi;
